import axios from 'axios';
import * as Constants from 'constants/Constants';
import { setLoggedInUser } from './termsAndConditionsActions';
import { updateAccountId, updateUserName, updateUserResource } from './headerAction';
import {
    CLEAR_SESSION_VALUES,
    SET_SESSION_VALUES,
    UPDATE_SESSION_VALUES,
    ENABLE_HEADER_OPERATIONS
} from './types';
import {
    isBlank,
    isNotBlank,
    isNotEmptyList,
    isNotEmptyObject
} from 'components/Common/Utils/StringUtils';
import {
    transformPermission,
    getURLAccountId,
    generateUserRoleEnabledFlag
} from 'components/Common/Utils/ResourceUtils';
import { getAccountV2ById } from './accountActions';
import { IS_TITAN_SERVICE_ENABLED } from 'components/TrustCenter/store/actions/types';

const userPermissionPath = `https://${Constants.TRUSTCENTER_ENDPOINT}/iam/v2/users`;
const accountsPath = `https://${Constants.TRUSTCENTER_ENDPOINT}/api/core/v2/accounts`;
const urlAccountId = sessionStorage.getItem('urlAccountId');

export const getValuesForSession = (res, allowRoute) => {
    return (dispatch) => {

        /**
         * Default values for the session
         */
        var value = {
            user_role: '',
            accountTypes: '',
            objectId: '',
            people_net_id: null,
            tenant_id: null
        };

        /**
         * DEPRECTATED FUNCTION - USE getUserRoles instead
         * @param {} roles 
         * @returns 
         */
        const getUserRole = (roles) => {
            const roleNames = roles.map((role) => role.name);
            if (roleNames.includes('Trimble Admin')) {
                return 'SYSTEM_ADMIN';
            } else if (roleNames.includes('Carrier Admin')) {
                return 'ACCOUNT_ADMIN';
            } else if (
                roleNames.includes('Visibility Provider Admin', 'Visibility Provider User')
            ) {
                return 'VISIBILITY_PROVIDER';
            }
            return 'USER';
        };

        /**
         * Returns a list of roles for the user
         * @param {Array<{name: string}>} roles
         * @returns {Array<string>}
         */
        const getUserRoles = (roles) => {
            return roles.reduce((acc, role) => {
                switch (role.name) {
                    case 'Trimble Admin':
                        acc.push('SYSTEM_ADMIN');
                        break;
                    case 'Carrier Admin':
                        acc.push('ACCOUNT_ADMIN');
                        break;
                    case 'Visibility Provider Admin':
                        acc.push('VISIBILITY_PROVIDER');
                        break;
                    case 'Visibility Provider User':
                        acc.push('VISIBILITY_PROVIDER');
                        break;
                    case 'Trimble Visibility Admin':
                        acc.push('VISIBILITY_ADMIN');
                }
                return acc;
            }, []);
        };

        if (isNotBlank(urlAccountId)) {
            dispatch(getAccountV2ById(urlAccountId));
        }
        return axios.get(userPermissionPath + `/${res.sub}`).then((userResponse) => {
            const { roles, userRole, accountObjectId: accountId } = userResponse?.data ?? {};
            value.user_role = generateUserRoleEnabledFlag() ? getUserRole(roles) : userRole;
            value.user_roles = getUserRoles(roles);
            const url = `https://${Constants.TRUSTCENTER_ENDPOINT}/iam/v2/users/${res?.sub}/products`;
            const headers = { accountId };
            axios
                .get(url, { headers })
                .then((response) => {
                    const services = response?.data?.modules?.find(
                        (module) => module?.name === 'Default'
                    )?.services;
                    dispatch(updateUserResource(transformPermission(services || [])));
                })
                .catch((error) => {
                    // Products/permissions are not required to finish session setup.
                    // Without a catch, a 500 becomes an uncaught rejection and CRA overlays.
                    console.warn('[Dashboard access] users/products failed; continuing without permissions', {
                        status: error?.response?.status,
                        url: error?.config?.url,
                        data: error?.response?.data,
                        accountId
                    });
                    dispatch(updateUserResource({}));
                });

            return axios.get(accountsPath + `/${res.account_id}`).then((response) => {
                value.accountTypes = response.data.accountTypes;
                value.objectId = response.data.objectId;
                return axios
                    .get(accountsPath + `/${res.account_id}` + '/references')
                    .then((refResponse) => {
                        if (isBlank(urlAccountId)) {
                            refResponse.data.forEach((name) => {
                                name.attributes.forEach((attribute) => {
                                    if (attribute.key === Constants.PEOPLE_NET_ID) {
                                        value.people_net_id = attribute.value;
                                    }
                                    if (attribute.key === Constants.TENANT_ID) {
                                        value.tenant_id = attribute.value;
                                    }
                                });
                            });
                        }
                        value.user_role === Constants.CARRIER_ADMIN &&
                            isNotEmptyList(refResponse?.data) &&
                            dispatch(setTitanServiceEnabledFlag(refResponse));
                        if (isBlank(urlAccountId)) {
                            dispatch(
                                updateUserSession(res, {
                                    ...value,
                                    isTitanServiceEnabled: getTitanServiceEnabledFlag(refResponse)
                                })
                            );
                        }
                    })
                    .catch(() => {
                        if (isBlank(urlAccountId)) {
                            dispatch(updateUserSession(res, value));
                        }
                    })
                    .finally(() => {
                        if (isNotBlank(urlAccountId)) {
                            dispatch(updateSelectedAccountReference(res, value));
                        }
                        if (allowRoute) {
                            allowRoute(true);
                        }
                    });
            });
        });
    };
};

export const updateSelectedAccountReference = (res, value) => {
    return (dispatch, getState) => {
        axios
            .get(accountsPath + '/' + `${getState().accounts.selectedAccount.id}` + '/references')
            .then((refResponse) => {
                refResponse.data.forEach((name) => {
                    name.attributes.forEach((attribute) => {
                        if (attribute.key === Constants.PEOPLE_NET_ID) {
                            value.people_net_id = attribute.value;
                        }
                        if (attribute.key === Constants.TENANT_ID) {
                            value.tenant_id = attribute.value;
                        }
                    });
                });
                isNotEmptyList(refResponse?.data) &&
                    dispatch(setTitanServiceEnabledFlag(refResponse));
                dispatch(
                    updateUserSession(res, {
                        ...value,
                        isTitanServiceEnabled: getTitanServiceEnabledFlag(refResponse)
                    })
                );
            })
            .catch(() => dispatch(updateUserSession(res, value)));
    };
};

export const updateUserSession = (res, value) => {
    return (dispatch) => {
        if (
            value.accountTypes.filter((type) => {
                return type === 'CARRIER';
            }).length > 0
        ) {
            dispatch(setLoggedInUser(value.objectId, res.tcx_user_id, res?.sub, res.account_name));
        }
        dispatch(updateUserName(res.given_name));
        dispatch(updateAccountId(value.objectId));
        const scac = value.accountTypes.map((type) => {
            if (type === 'CARRIER') {
                return type.scac;
            }
        })[0];
        const sessionValue = {
            isLoggedIn: true,
            userName: res.given_name,
            userId: res.tcx_user_id,
            userUUID: res.sub,
            userRole: value.user_role, // DEPRECTATED FIELD - USE userRoles instead. Only for backward compatibility.
            userRoles: value.user_roles,
            accountId: value.objectId,
            accountType: value.accountTypes,
            accountName: res.account_name,
            scac: scac !== null ? scac : '',
            isCarrier:
                value.accountTypes.filter((type) => {
                    return type === 'CARRIER';
                }).length > 0,
            tenant_id:
                value.tenant_id !== null
                    ? parseInt(value.tenant_id) < 0
                        ? ''
                        : value.tenant_id
                    : '',
            people_net_id: value.people_net_id !== null ? value.people_net_id : '',
            isCompanyIdMapped: isNotBlank(value.people_net_id),
            isTenantIdMapped: isNotBlank(value.tenant_id),
            isUser: value.user_role !== 'SYSTEM_ADMIN' && value.user_role !== 'ACCOUNT_ADMIN',
            selected_accountId: getURLAccountId(),
            isRedirectedURL: isNotBlank(getURLAccountId()),
            accountUuid: res.account_id,
            isTitanServiceEnabled: value.isTitanServiceEnabled
        };

        dispatch({
            type: SET_SESSION_VALUES,
            payload: sessionValue
        });
        dispatch({
            type: ENABLE_HEADER_OPERATIONS
        });
    };
};
export const updateSession = (value) => {
    return {
        type: UPDATE_SESSION_VALUES,
        payload: value
    };
};

export const clearSession = () => {
    return {
        type: CLEAR_SESSION_VALUES,
        payload: {}
    };
};

const getTitanServiceEnabledFlag = (refResponse) => {
    const enabledResource = refResponse.data.find(({ name }) => name === 'enabled-resources');
    if (isNotEmptyObject(enabledResource)) {
        return (
            enabledResource.attributes?.find(({ key }) => key === 'titan_service')?.value === 'true'
        );
    }
    return false;
};

const setTitanServiceEnabledFlag = (refResponse) => (dispatch) => {
    const isTitanServiceEnabled = getTitanServiceEnabledFlag(refResponse);
    dispatch({
        type: IS_TITAN_SERVICE_ENABLED,
        payload: isTitanServiceEnabled
    });
};
